import {ICD10_FETCH_STARTED, ICD10_FETCH_COMPLETED} from "../constants";

const initialState = {
  collection: [],
  isFetching: false
};

export function icd10s(state = initialState, action) {
  switch (action.type) {
    case ICD10_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case ICD10_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.content,
        isFetching: false
      });
    default:
      return state;
  }
}
